import { Component, Input } from '@angular/core';

import { Debt } from '../../../core/data';

@Component({
  templateUrl: './default_process.component.html',
  selector: 'app-default-process',
})
export class DefaultProcessComponent {
  @Input() debt: Debt;
  @Input() module: string;

  cdlMaxDays = 74;
  dayPercent = 130 / this.cdlMaxDays;
  sixQLeft = 14 * this.dayPercent;
  twentyOneDLeft = 40 * this.dayPercent;
  defaultedLeft = 100;

  get show() {
    return this.debt.status.startsWith('cdl_');
  }

  get cdlProgress() {
    var currentDays = this.debt.days_in_status;

    return this.debt.status.startsWith('cdl_') ? Math.min((currentDays * this.dayPercent), 100) : 0;
  }

  get reviewDate(): string {
    let date: Date = new Date(this.debt.status_changed_at);

    // return date formatted to d/m/Y
    return date.toLocaleDateString('en-GB');
  }

  get sixQDate(): string {
    let date: Date = new Date(this.debt.status_changed_at);
    date.setDate(date.getDate() + 14);

    // return date formatted to d/m/Y
    return date.toLocaleDateString('en-GB');
  }

  get twentyOneDate(): string {
    let date: Date = new Date(this.debt.status_changed_at);
    date.setDate(date.getDate() + 44);

    // return date formatted to d/m/Y
    return date.toLocaleDateString('en-GB');
  }

  get defaultedDate(): string {
    let date: Date = new Date(this.debt.status_changed_at);
    date.setDate(date.getDate() + 74);

    // return date formatted to d/m/Y
    return date.toLocaleDateString('en-GB');
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/debts/default_process.component.ts